import { withStyles } from '@material-ui/core/styles';
import { Label } from 'core';
import { Button } from 'core/components/button';
import Field from 'core/components/form/form.v2';
import { withStore } from 'core/store';
import { Form, Formik } from 'formik';
import flowRight from 'lodash-es/flowRight';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import styles from './footer.styles';
import { validationSchema } from './footer.validation';

const FooterRight = ({ classes, disabled, handleSubmit, loadingEmail, store }) => {
  const {
    quote: { offer, loading }
  } = store;
  const staffHref = useMemo(() => {
    if (offer) {
      return offer.id;
    }
  }, [offer]);
  return (
    <Formik
      initialValues={{
        ...offer.quote,
        email: offer.quote.email || ''
      }}
      handleSubmit={handleSubmit}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <div className={classes.footerRightContainer}>
        <Form className={classes.form}>
          <Field mode="light" type="string" name="email" id="email" label="Email" />
          <Button
            loading={loadingEmail}
            disabled={disabled || loadingEmail || loading}
            variant="contained"
            color="secondary"
            type="submit"
            className={classes.emailBtn}
          >
            Email Link
          </Button>
        </Form>
        <Button
          target="_blank"
          href={`/offer/${staffHref}`}
          disabled={disabled || loading || loadingEmail}
          loading={loading}
          variant="contained"
          color="primary"
          className={classes.btn}
        >
          <Label className={classes.btnLabel}>Go to offer</Label>
        </Button>
      </div>
    </Formik>
  );
};

FooterRight.propTypes = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  loadingEmail: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  store: PropTypes.object.isRequired
};

export default flowRight(withStyles(styles), withStore)(FooterRight);
